import { cn } from 'ui/lib/utils';

const sizeMap = {
	sm: 16,
	md: 24,
	lg: 32
} as const;

type SpinnerSize = keyof typeof sizeMap;

interface SpinnerProps {
	size?: SpinnerSize;
	className?: string;
	'data-testid'?: string;
}

export function Spinner({ size = 'md', className, 'data-testid': testId = 'spinner' }: SpinnerProps) {
	const px = sizeMap[size];

	return (
		<svg
			data-testid={testId}
			className={cn('animate-spin', className)}
			width={px}
			height={px}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			role="status"
			aria-label="Cargando">
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="3"
				strokeLinecap="round"
				className="opacity-20"
			/>
			<path
				d="M12 2a10 10 0 0 1 10 10"
				stroke="var(--safi-color-cta)"
				strokeWidth="3"
				strokeLinecap="round"
			/>
		</svg>
	);
}

export default Spinner;
